export default "__VITE_ASSET__D9JyV$Fg__"